<div class="chat-activity" *ngIf="activity">
  <div class="chat-activity__bubble">
    <div class="chat-activity__spinner" aria-hidden="true">
      <span class="chat-activity__dot"></span>
      <span class="chat-activity__dot"></span>
      <span class="chat-activity__dot"></span>
    </div>

    <div class="chat-activity__label-viewport" [@labelTransition]="frames[0]?.id">
      <span
        class="chat-activity__label"
        *ngFor="let frame of frames; trackBy: trackByFrameId"
      >{{ frame.text }}</span>
    </div>
  </div>
</div>
